module.exports = "<!-- <app-home-navigate-bar></app-home-navigate-bar> -->\r\n<div id=\"container\" style=\"height:calc(100% - 55px);\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-report/home-report.component.html
// module id = ./src/app/modules/home/components/home-report/home-report.component.html
// module chunks = main